/**
 * A utility function to allow us to access nested properties of an object
 * more easily using dot notation.
 *
 * Sometimes it is easier to access nested properties of an object using
 * this approach, so this function is here to support that.
 *
 * @param path - The path to the property you want to access e.g. 'a.b.c'
 * @param obj - The object to access the property on
 * @param defaultValue - An optional default value to return if the path does not exist
 * @returns The value at the given path or the default value if the path does not exist,
 *          or undefined if no default value is provided
 */
export function get<T>(path: string, obj: object, defaultValue?: T): T {
  const keys = path.split('.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let result: any = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return defaultValue as T;
    }
  }

  return result as T;
}
